module.exports = __webpack_public_path__ + "img/past-events_mls-cup.30660e5d.jpg";